export default __webpack_public_path__ + "assets/front/scss/error.32d2a67e80ee944f3c1157833b104dd4.css";